export default __webpack_public_path__ + "24e06b580f72b9d58eec6e7c9b12f21e.png";